export const categorieName = {
    cars : "Транспорт",
    houses : "Недвижимость",
    business : "Бизнес",
    clothes : "Одежда",
    other : "Прочее",
}